module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"lodash","commonjs2":"lodash","amd":"_","root":"_"}
// module id = 0
// module chunks = 0